module.exports = __webpack_public_path__ + "img/magento-code-review.82e2f2dc.jpg";